<template>
    <div>
        <ui-select
            :label="label"
            :keys="{ label:'name', value: 'id' }"
            placeholder="Pick a Team Member"
            :options="options"
            :disabled="isLoading"
            :icon="icon"
            v-model="selected"
            @change="handleChange"
            :has-search="true"
        ></ui-select>
    </div>
</template>

<script>
    import { UserResource } from '../../../classes/Api/User'

    export default {
        props: {
            label: {
                type: String,
            },
            value: {
                type: Object,
            },
            teamId: {
                type: Number
            },
            icon: {
                type: String,
                default() {
                    return ''
                }
            }
        },
        watch: {
            value: {
                handler(newVal) {
                    this.selected = newVal;
                },
                deep: true,
            }
        },
        data() {
            return {
                selected: {},
                options: [],
                isLoading: true,
            }
        },
        mounted() {
            this.reset()
        },
        methods: {
            reset() {
                this.isLoading = true;

                this.selected = this.value ?? {};

                let params = { }

                if (this.teamId) {
                    params.team = this.teamId
                }

                UserResource.all(params).then(response => {
                    this.isLoading = false;

                    this.options = response.data;
                })
            },
            handleChange(e) {
                this.$emit('input', e);
            }
        }
    }
</script>